module.exports = __webpack_public_path__ + "static/Teri_Aradhana_Bridge_Music-032bffdba38c6ae6c358149ab60b475d.jpg";